export default __webpack_public_path__ + "static/SRUS RT175 - Especification Del Producto y Datos Técnicos-f49f73689d0fa5aba1fe043b0fb7a157.pdf";